import { NavLink } from "react-router";
import { List as WindowsList } from "react-window";

import Avatar from "@/design/components/Avatar";
import ContentLoader from "@/design/components/ContentLoader";
import PageTitle from "@/design/components/PageTitle";

import { Box, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Stack } from "@mui/material";
import PropTypes from "prop-types";

function MasterListVirtualized({
  title,
  fabBar = false,
  list,
  listItemProps,
  contentLoaderProps,
  hideContentLoader,
  actions,
  ...props
}) {
  const ResultItem = ({ index, style }) => {
    if (index === 0) {
      return (
        <Stack
          direction="row"
          style={{ ...style, top: (style?.top ?? 0) + 64, height: "auto" }}
          sx={{
            alignItems: "center",
            gap: 1,
          }}
        >
          {actions}
          <PageTitle sx={{ pl: actions ? 0 : 2 }} disableGutters>
            {title}
          </PageTitle>
        </Stack>
      );
    }

    if (index > 0 && index <= list.length) {
      const realIndex = index - 1;
      const domain = list[realIndex];

      return (
        <ListItem disablePadding key={domain.context} sx={{ ...style, top: (style?.top ?? 0) + 64, minHeight: 48 }}>
          <ListItemButton
            onClick={() => listItemProps.onClick?.(domain)}
            selected={listItemProps.selected(domain)}
            sx={{ minHeight: 48 }}
            component={listItemProps.to ? NavLink : undefined}
            to={listItemProps.to?.(domain)}
          >
            <ListItemAvatar>
              <Avatar text={listItemProps.primary(domain)} icon={listItemProps.icon} />
            </ListItemAvatar>
            <ListItemText
              primary={listItemProps.primary(domain)}
              secondary={listItemProps.secondary && listItemProps.secondary(domain)}
            />
          </ListItemButton>
        </ListItem>
      );
    }

    if (index === list.length + 1) {
      return (
        <Box
          style={{
            ...style,
            top: (style?.top ?? 0) + 64,
            height: 8 * (fabBar ? 8.5 : 2),
          }}
        />
      );
    }
  };

  return (
    <Box
      sx={{
        pb: 0,
        pt: 0,
      }}
    >
      <List component="nav" {...props}>
        {hideContentLoader ? (
          <WindowsList
            rowComponent={ResultItem}
            rowHeight={50}
            rowCount={list.length + 2}
            rowProps={{ list }}
            style={{
              width: "100%",
              height: "100dvh",
              paddingTop: `64px`,
            }}
          />
        ) : (
          <ContentLoader {...contentLoaderProps} />
        )}
      </List>
    </Box>
  );
}

MasterListVirtualized.propTypes = {
  actions: PropTypes.node,
  title: PropTypes.string,
  fabBar: PropTypes.bool,
  children: PropTypes.node,
  list: PropTypes.array,
  listItemProps: PropTypes.object,
  contentLoaderProps: PropTypes.object,
  hideContentLoader: PropTypes.bool,
};

export default MasterListVirtualized;
